import { normalizeEmailList } from '@/modules/common/validations/email-list-schema';
import { areValuesEqual } from '@/utils/form-state.utils';

import { Client, PaymentTerms } from '../types';
import { ClientInfoFormData } from '../validations';

const QUICKBOOKS_SYNCED_FIELDS = [
  'name',
  'email',
  'paymentTerms',
  'billingAddress',
  'shippingAddress',
] as const;

export type QuickBooksSyncedField = (typeof QUICKBOOKS_SYNCED_FIELDS)[number];

export type QuickBooksSyncedValues = Pick<ClientInfoFormData, QuickBooksSyncedField>;

export const mapClientToQuickBooksSyncedValues = (client?: Client): QuickBooksSyncedValues => ({
  name: client?.name ?? '',
  email: normalizeEmailList(client?.email ?? ''),
  paymentTerms: client?.paymentTerms ?? PaymentTerms.Net30,
  billingAddress: client?.billingAddress ?? '',
  shippingAddress: client?.shippingAddress ?? '',
});

export const findChangedQuickBooksSyncedFields = (
  current: QuickBooksSyncedValues,
  initial: QuickBooksSyncedValues
): QuickBooksSyncedField[] =>
  QUICKBOOKS_SYNCED_FIELDS.filter(field => !areValuesEqual(current[field], initial[field]));
